var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.visible),expression:"visible"}],staticClass:"loader-generic-loader"},[_c('v-progress-linear',{staticClass:"ma-0",attrs:{"indeterminate":true,"height":2,"background-opacity":0}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }